// extracted by mini-css-extract-plugin
export var btn = "button-module--btn---rqWv";
export var blue = "button-module--blue--LsP+r";
export var orange = "button-module--orange--ij3Xw";
export var pink = "button-module--pink--69Jxl";
export var shadow = "button-module--shadow--Gljkr";